import { useState } from "react";
import { Provider } from "react-redux";
import store from "../src/Redux/store";
import "./App.css";
import Cart from "./component/Cart/Cart";
import Home from "./component/Home/Home/Home";
import Navbar from "./component/Navbar/Navbar";

function App() {

  const[isHome, setIsHome] = useState(true);

  return (
    <Provider store={store}>
      <Navbar IsHome={isHome} setIsHome= {setIsHome}></Navbar>
      {
        isHome && <Home></Home>
      }
      {
        !isHome && <Cart></Cart>
      }   
    </Provider>
  );
}

export default App;
